import { effectiveRentRule } from './effective-rent.calc.js';
import { netRentableAreaRule } from './net-rentable-area.calc.js';
import { hkRetailSizePairRules } from './hk-retail-size-pairs.calc.js';
import { spaceRentAmountRules } from './rent-amounts.calc.js';
/** Every space-domain rule (T2.4: S1 net-rentable-area, S2/S3 HK-Retail pairs, S4 effective rent, S5 amounts). */
export const spaceRules = [effectiveRentRule, netRentableAreaRule, ...hkRetailSizePairRules, ...spaceRentAmountRules];
export const spaceRegistry = {
  domain: 'space',
  rules: spaceRules
};
